import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M28 12H19.5866L20.8533 5.90663L20.8933 5.47996C20.8933 4.93329 20.6666 4.42663 20.3066 4.06663L18.8933 2.66663L10.12 11.4533C9.62665 11.9333 9.33331 12.6 9.33331 13.3333V26.6666C9.33331 28.1333 10.5333 29.3333 12 29.3333H24C25.1066 29.3333 26.0533 28.6666 26.4533 27.7066L30.48 18.3066C30.6 18 30.6666 17.68 30.6666 17.3333V14.6666C30.6666 13.2 29.4666 12 28 12ZM28 17.3333L24 26.6666H12V13.3333L17.7866 7.54663L16.3066 14.6666H28V17.3333ZM1.33331 13.3333H6.66665V29.3333H1.33331V13.3333Z"
})), 'ThumbUp', {
  viewBox: '0 0 16 16'
});